<template>
  <div class="point-order-detail">
    <nav-bar
      :isFixed="true"
      :goBack="goBack"
      :title="$t('訂單詳情')"
      :bgc="'background-color: #ffffff;'"
    >
        <template v-slot:right>
        <img @click="service" class="service-icon" src="@/assets/image/order/service.png">
      </template>
    </nav-bar>
    <div class="order-box" :class="{ 'top-box': !isMobile() }">
        <div class="order-type" v-if="orderDetail">
            <img class="type-icon" src="@/assets/image/pointsMall/type.png">
            <span class="type-text">
                {{ getStatusText(orderDetail.status) }}
            </span>
        </div>
        <div class="express-info" v-if="orderDetail">
            <div class="user-box">
                <div class="name">{{ orderDetail.name }}</div>
                <div class="name">{{ orderDetail.phone }}</div>
            </div>
            <div class='address'>
                {{ orderDetail.area }} {{ orderDetail.address }}
            </div>
        </div>
        <div class="other-info" v-if="orderDetail">
            <div class="good-box">
                <div class="good-item" v-for="(product, index) in orderDetail.products" :key="index" @click="goToProductDetail(product.productId)">
                    <img class="good-img" :src="BASE_IMG + product.picturePath" @error="imgOnError($event)">
                    <div class="good-item-info-box">
                        <div class="good-name">
                            {{ getCurrentLanguage() === 'zh' ? product.productName : product.productNameEn }}
                        </div>
                        <div class="point-and-num">
                            <div class="point">
                                {{ product.productPoints }} <span>{{' ' + $t("積分") }}</span>
                            </div>
                            <div class="num">
                                <span>{{' ' + $t("數量") }}</span>{{ product.amount }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="d-m">
                <span class="title">
                    {{ $t("配送方式") }}
                </span>
                <span class="info">
                   {{ orderDetail.expressName?orderDetail.expressName:'-' }}
                </span>
            </div>
            <div class="total-box">
                <div class="line-box" style="margin-bottom:16px;">
                    <span class="head-text">
                        {{ $t("訂單總計") }}({{ orderDetail.products.reduce((sum, product) => sum + product.amount, 0) }}{{ $t("件") }})
                    </span>
                </div>
                <!-- <div class="line-box" style="margin-bottom:16px;">
                    <span class="grey-text">
                        {{ $t("總賬單金額") }}
                    </span>
                    <span class='big-text'>
                        HK$600.00
                    </span>
                </div> -->
                <div class="line-box" >
                    <span class="head-text" >
                        {{ $t("總金額") }}
                    </span>
                    <span class="red-text">
                        {{ orderDetail.totalPoints }}<span>{{' ' + $t("積分") }}</span>
                    </span>
                </div>
            </div>
            <div class="else-box">
                <div class="line-box" style="margin-bottom:16px;">
                    <span class="grey-text">
                        {{ $t("訂單號") }}
                    </span>
                    <div class='n-text num-box'>
                        <span>{{ orderDetail.orderNo }}</span>
                        <img class="num-img" src="@/assets/image/pointsMall/edit.png" @click="copyOrderNo(orderDetail.orderNo)">
                    </div>
                </div>
                <div class="line-box" style="margin-bottom:16px;">
                    <span class="grey-text">
                        {{ $t("創建時間") }}
                    </span>
                    <div class='n-text num-box'>
                        <span>{{ orderDetail.payTime }}</span>

                    </div>
                </div>
                <div class="line-box" style="margin-bottom:16px;" v-if="orderDetail.shippedTime">
                    <span class="grey-text">
                        {{ $t("發貨時間") }}
                    </span>
                    <div class='n-text num-box'>
                        <span>{{ orderDetail.shippedTime }}</span>

                    </div>
                </div>
                <div class="line-box" style="margin-bottom:16px;" v-if="orderDetail.mailNo">
                    <span class="grey-text">
                        {{ $t("運單號") }}
                    </span>
                    <div class='n-text num-box' @click="getViewLogistics(orderDetail)">
                        <span  style="color: #3491FA;">{{ orderDetail.mailNo }}</span>
        
                    </div>
                </div>
            </div>
        </div>
        <div class="loading" v-else>
            <van-loading size="24px" color="#90d12e">{{ $t('加載中') }}...</van-loading>
        </div>
    </div>
    <div class="b-btn-box">
        <div class="btn" @click="buyAgain">
            {{ $t('再次購買') }}
        </div>
    </div>
  </div>
</template>

<script>
import { pointsOrderDetail } from "@/api/pointsMall";
import { getIndexRith } from "@/api/home";
import mixins from "@/utils/mixins.js"
export default {
    mixins: [mixins],
  name: "PointOrderDetail",
  data() {
    return {
      orderDetail: null,
      defaultImage: require("@/assets/image/default.png")
    };
  },
  mounted() {
    this.getOrderDetail();
  },
  methods: {
    isMobile() {
      var u = navigator.userAgent;
      const isAndroid =
        (u.indexOf("Android") > -1 || u.indexOf("Adr") > -1) &&
        u.indexOf("MMMMessenger") > -1; //android终端
      const isIos =
        !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) &&
        u.indexOf("MMMMessenger") > -1; //ios终端
      return isAndroid || isIos;
    },
    goBack() {
      this.$router.back();
    },
    async getOrderDetail() {
      const orderNo = this.$route.query.orderNo;
      if (!orderNo) {
        this.$toast(this.$t('訂單號不存在'));
        return;
      }
      try {
        const res = await pointsOrderDetail(orderNo);
        if (res.resultID === 1200) {
          this.orderDetail = res.data;
          console.log('訂單詳情:', this.orderDetail);
        } else {
          this.$toast(res.message || this.$t('獲取訂單詳情失敗'));
        }
      } catch (error) {
        console.error('獲取訂單詳情失敗:', error);
        this.$toast(this.$t('獲取訂單詳情失敗'));
      }
    },
    async service(){
      const res = await getIndexRith({ type: 2 })
      location.href =`https://wa.me/${res.data.rithWANo}?text=I have some questions about orderid：${this.$route.query.orderNo}`

    },
    imgOnError(e) {
      e.target.src = this.defaultImage;
    },
    getStatusText(status) {
      switch(status) {
        case 0:
          return this.$t('待付款');
        case 1:
          return this.$t('正在支付');
        case 2:
          return this.$t('待發貨');
        case 3:
          return this.$t('待收貨');
        case 4:
          return this.$t('交易成功，已收貨');
        case 5:
          return this.$t('交易關閉，訂單異常');
        case 6:
          return this.$t('預購中');
        case 7:
          return this.$t('預定中（已支付定金）');
        case 8:
          return this.$t('預定中（已支付尾款）');
        case 9:
          return this.$t('待審核');
        default:
          return this.$t('未知狀態');
      }
    },
    copyOrderNo(orderNo) {
      if (navigator.clipboard && window.isSecureContext) {
        // 使用现代的Clipboard API
        navigator.clipboard.writeText(orderNo).then(() => {
          this.$toast(this.$t('複製成功'));
        }).catch(err => {
          console.error('複製失敗:', err);
          this.$toast(this.$t('複製失敗'));
        });
      } else {
        // 使用传统的方法
        const textArea = document.createElement('textarea');
        textArea.value = orderNo;
        textArea.style.position = 'fixed';
        textArea.style.left = '-999999px';
        textArea.style.top = '-999999px';
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();
        try {
          const result = document.execCommand('copy');
          if (result) {
            this.$toast(this.$t('複製成功'));
          } else {
            this.$toast(this.$t('複製失敗'));
          }
        } catch (err) {
          console.error('複製失敗:', err);
          this.$toast(this.$t('複製失敗'));
        }
        document.body.removeChild(textArea);
      }
    },
    buyAgain() {
      if (this.orderDetail && this.orderDetail.products && this.orderDetail.products.length > 0) {
        const firstProduct = this.orderDetail.products[0];
        const pointsProductId = firstProduct.productId;
        const amount = firstProduct.amount;
        this.$router.push(`/pointsMall/confirm?pointsProductId=${pointsProductId}&amount=${amount}`);
      } else {
        this.$toast(this.$t('商品信息不存在'));
      }
    },
    goToProductDetail(productId) {
      this.$router.push(`/pointsMall/detail/${productId}`);
    },
    getCurrentLanguage() {
      const langEnv = localStorage.getItem('langEnv');
      return langEnv === '2' ? 'en' : 'zh';
    },
    getViewLogistics(item) {
      this.$router.push({
        path: `/order/logistics/${item.orderNo}`,
        query: {
          type: "1",
        },
      });
    }
  },
}
</script>

<style lang="scss" scoped>
.point-order-detail {
  width: 100%;
  min-height: 100vh;
  background-color: #f8f8f8;

  box-sizing: border-box;

  .top-box {
    padding-top: 44px;
  }
  .order-box{

      max-height: calc(100vh - 100px);
      overflow-y: auto;
      .order-type {
        padding:16px 28px;
        background: #FFFFFF;
        border-radius: 0px 0px 16px 16px;
        display:flex;
        align-items:center;
        margin-bottom: 12px;
        .type-icon{
            width:24px;
            height:24px;
            margin-right:2px;
        }
        .type-text{

            font-family: PingFang SC, PingFang SC;
            font-weight: 500;
            font-size: 18px;
            color: #1A1A1A;

        }
    }
    &::-webkit-scrollbar {
      width: 4px;
    }
    &::-webkit-scrollbar-track {
      background: #f1f1f1;
      border-radius: 2px;
    }
    &::-webkit-scrollbar-thumb {
      background: #c1c1c1;
      border-radius: 2px;
    }
    &::-webkit-scrollbar-thumb:hover {
      background: #a8a8a8;
    }
    .express-info{
        padding:16px;
        background: #FFFFFF;
        border-radius: 16px 16px 16px 16px;
        margin-bottom:12px;
        .user-box {
            display:flex;
            align-items:center;
            .name {

                font-family: PingFang SC, PingFang SC;
                font-weight: 500;
                font-size: 15px;
                color: #1A1A1A;

                font-style: normal;
                margin-right:12px;
            }
            .phone{

                font-family: PingFang SC, PingFang SC;
                font-weight: 500;
                font-size: 15px;
                color: #1A1A1A;
                line-height: 24px;

                font-style: normal;

            }
        }
        .address{
            margin-top:2px;
            width: 343px;

            font-family: PingFang SC, PingFang SC;
            font-weight: 400;
            font-size: 13px;
            color: #666666;
            line-height: 20px;
            text-align: left;
            font-style: normal;
            word-break: break-all;
            white-space: normal;
            word-wrap: break-word;

        }
    }
    .other-info{
        padding:16px;
        background-color:#ffffff;
        border-radius:16px;
        .good-box{
            .good-item{
                display:flex;
                .good-img{
                    width: 120px;
                    height: 120px;
                }
                .good-item-info-box{
                    display:flex;
                    flex-direction:column;
                    justify-content:space-between;
                    margin-top:2px;
                    flex: 1;
                    padding-left:16px;
                    .good-name{
                        font-family: PingFang SC, PingFang SC;
                        font-weight: 400;
                        font-size: 13px;
                        color: #1A1A1A;
                        line-height: 20px;
                        text-align: left;
                        font-style: normal;
                    }
                    .point-and-num{
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        .point{

                            font-family: PingFang SC, PingFang SC;
                            font-weight: 800;
                            font-size: 16px;
                            color: #F82207;
                            line-height: 30px;
                            text-align: left;

                        }
                        .num{

                            font-family: PingFang SC, PingFang SC;
                            font-weight: 400;
                            font-size: 12px;
                            color: #1A1A1A;
                            line-height: 18px;
                            text-align: left;
                            font-style: normal;
                            text-transform: none;
                        }
                    }
                }
            }
        }
        .d-m{
            padding: 16px 0;
            display:flex;
            align-items:center;
            justify-content:space-between;
            border-bottom: 1px solid #F8F8F8;
            .title{

                font-family: PingFang SC, PingFang SC;
                font-weight: 400;
                font-size: 15px;
                color: #666666;
                line-height: 24px;

            }
            .info{

                font-family: PingFang SC, PingFang SC;
                font-weight: 400;
                font-size: 14px;
                color: #1A1A1A;
                line-height: 22px;

            }
        }
        .total-box{
            padding:16px 0;
            border-bottom: 1px solid #F8F8F8;
            .line-box{
                display:flex;
                justify-content:space-between;
                align-items:center;

            }
        }
        .else-box{
            padding:16px 0;
            .line-box{
                display:flex;
                justify-content:space-between;
                align-items:center;

            }
            .num-box{
                display:flex;
                align-items:center;
            }
            .num-img{
                width:16px;
                height:16px;
                margin-left:4px;
            }
        }
    }
  }
  .b-btn-box{
    padding:9px 16px 24px 16px;
    position:fixed;
    left:0;
    bottom:0;
    width:100%;
    background-color:#ffffff;
    .btn{
        width: 100%;
        height: 44px;
        background: #90D12E;
        border-radius: 8px 8px 8px 8px;
        display:flex;
        justify-content:center;
        align-items:center;

        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 15px;
        color: #FFFFFF;
        line-height: 24px;

    }
  }
  .n-text{

    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #1A1A1A;
    line-height: 22px;

  }
  .big-text{
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 15px;
        color: #1A1A1A;
        line-height: 24px;

    }
    .red-text{

        font-family: PingFang SC, PingFang SC;
        font-weight: 800;
        font-size: 16px;
        color: #F82207;
        line-height: 24px;

    }
  .grey-text{

    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 15px;
    color: #666666;
    line-height: 24px;

  }
  .head-text{

    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 16px;
    color: #1A1A1A;
    line-height: 24px;

  }
  .hello {
    font-size: 18px;
    color: #333;
    text-align: center;
    margin-top: 100px;
  }
  .service-icon{
    width: 22px;
    height: 22px;
  }
}
</style>
